
import { pathsRelatedToFactFindSections } from '@/helpers/notePathHelper';
import { mapGetters } from 'vuex';

export default {
  name: 'edit-note',

  props: {
    note: {
      type: Object,
    },
    model_type: {
      type: String,
    },
    model_uuid: {
      type: String,
    },
    showActionButtons: {
      type: Boolean,
      default: false,
    },
    isWorking: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters('user', ['isClient']),
    showVisibleToggleForEditableNote() {
      if (pathsRelatedToFactFindSections.includes(this.note?.path)) {
        return true;
      }

      return false;
    },
  },
  methods: {
    cancelEditing() {
      this.$emit('cancel-editing');
    },
    updateNote() {
      this.$emit('update-note', this.note);
    },
  },
};
